import { IPanelProps, Panel } from "core/decorators/Panel";
import { Form, Input } from "decorator-form";
import InputType from "common/form/InputType";
import React from "react";

import TokenSession from "core/util/session/TokenSession";
import { ICompanyFragmentProps } from "./IntelCompanyFragments";
import { BlockView } from "common/views/block/BlockView.view";
import { IFragmentLayoutConfig, FragmentLayout } from "core/components/FragmentLayout";
import * as fragments from "./IntelCompanyFragments";
import { FragmentProvider } from "core/components/FragmentProvider";
import { ILayout } from "common/form/fields/layout/ILayoutType";

const companyFragmentInput = FragmentProvider.getLayoutInput(fragments);

@Form ({title: "Intel Company Details Panel"})
class IntelCompanyConfig {
    @Input({type: companyFragmentInput, title: "Layout"})
	public layout: ILayout<IFragmentLayoutConfig>;
    
    @Input({type: InputType.JSON, title: "Company Map JSON"})
	public companyMap?: any;
}

@Panel({id:"intel-company-details", configClass:IntelCompanyConfig})
class IntelCompanyDetails extends React.Component<IPanelProps<IntelCompanyConfig>> {

    public render() {
        const { config } = this.props;
        const userEmail = TokenSession.getUser().email;
        const emailDomain = userEmail.substring(userEmail.indexOf('@')+1);
        let title = '';
        let companyLogo = '';
        
        if (config.companyMap) {
            var cJson = config.companyMap;
            
            for (var c of cJson) {
                if (c.emailDomain==emailDomain) {
                    title = c.title;
                    companyLogo = c.logo;
                    break;
                }
            }
        }

		const props: ICompanyFragmentProps = {
			title: title,
			companyLogo: companyLogo			
		};

		return (
			<BlockView viewKey="block">
				<FragmentLayout layout={config.layout} fragments={fragments} props={props} />
			</BlockView>
        );
        
        /*

        return (
            <Label k="user.name" v="User name: ${user}" args={{userEmail}}></Label>
        );
        */
    }
}


// WEBPACK FOOTER //
// ./src/panels/client/intelrco/IntelCompanyDetails.panel.tsx